import { create } from "zustand";

/** "Take me to that file."
 *
 * A button that says you can do something to a file somewhere else has to put
 * you in front of that file. The inspector's Folder View link used to open the
 * pane and stop — leaving you to find the row yourself in a library of 74, which
 * is the part that made it annoying rather than helpful.
 *
 * The id is the document or node id; `at` is a timestamp so asking for the SAME
 * file twice still re-triggers the flash. */
interface FileRevealState {
  id: string | null;
  at: number;
  reveal: (id: string) => void;
  clearReveal: () => void;
}

export const useFileReveal = create<FileRevealState>((set) => ({
  id: null,
  at: 0,
  reveal: (id) => set({ id, at: Date.now() }),
  clearReveal: () => set({ id: null, at: 0 }),
}));
